// Сгенерированное соответствие «русская подпись → языковой ключ».
//
// Нужно потому, что часть подписей передаётся в хелперы text/area/sel
// позиционным аргументом, а не свойством label: "…". Такие подписи получают
// ключ во время выполнения через usiKeyForText().
//
// Файл сгенерирован из usiFormSchema.js и usiFormSchemasRest.js — при
// добавлении новых подписей перегенерировать тем же скриптом.

export const USI_LABEL_KEYS = {
  "2 / 3 / 4 / 5": "usi.lbl.2_3_4_5",
  "Акустические тени": "usi.lbl.akusticheskie_teni",
  "anteversio / anteflexio": "usi.lbl.anteversio_anteflexio",
  "Аорта": "usi.lbl.aorta",
  "Артерия": "usi.lbl.arteriya",
  "Артерия и сторона": "usi.lbl.arteriya_i_storona",
  "Артерия / сегмент": "usi.lbl.arteriya_segment",
  "Асцит": "usi.lbl.ascit",
  "Базилярная": "usi.lbl.bazilyarnaya",
  "Бедренная вена слева, с": "usi.lbl.bedrennaya_vena_sleva_s",
  "Бедренная вена справа, с": "usi.lbl.bedrennaya_vena_sprava_s",
  "BI-RADS": "usi.lbl.bi_rads",
  "Бифуркации общих сонных артерий": "usi.lbl.bifurkacii_obschih_sonnyh_arteriy",
  "Большая подкожная вена слева, с": "usi.lbl.bolshaya_podkozhnaya_vena_sleva_s",
  "Большая подкожная вена справа, с": "usi.lbl.bolshaya_podkozhnaya_vena_sprava_s",
  "Брюшная аорта": "usi.lbl.bryushnaya_aorta",
  "Бурсы": "usi.lbl.bursy",
  "ЦДК": "usi.lbl.cdk",
  "Центральные / проксимальные венозные сегменты": "usi.lbl.centralnye_proksimalnye_venoznye_segmenty",
  "Чревный ствол": "usi.lbl.chrevnyy_stvol",
  "Цветовое допплеровское картирование": "usi.lbl.cvetovoe_dopplerovskoe_kartirovanie",
  "Цветовое допплеровское картирование почек": "usi.lbl.cvetovoe_dopplerovskoe_kartirovanie_pochek",
  "Цветовое / энергетическое допплеровское картирование": "usi.lbl.cvetovoe_energeticheskoe_dopplerovskoe_kartirovanie",
  "Цветовое заполнение": "usi.lbl.cvetovoe_zapolnenie",
  "Цветовой балл / васкуляризация": "usi.lbl.cvetovoy_ball_vaskulyarizaciya",
  "да": "usi.lbl.da",
  "Дата последней менструации": "usi.lbl.data_posledney_menstruacii",
  "День менструального цикла / менопауза": "usi.lbl.den_menstrualnogo_cikla_menopauza",
  "День менструального цикла / постменопауза": "usi.lbl.den_menstrualnogo_cikla_postmenopauza",
  "Диаметр общего печеночного протока, мм": "usi.lbl.diametr_obschego_pechenochnogo_protoka_mm",
  "Диаметр общего желчного протока, мм": "usi.lbl.diametr_obschego_zhelchnogo_protoka_mm",
  "Диаметр редуцирован на, %": "usi.lbl.diametr_reducirovan_na",
  "Диаметр слева, мм": "usi.lbl.diametr_sleva_mm",
  "Диаметр справа, мм": "usi.lbl.diametr_sprava_mm",
  "Диаметр воротной вены, мм": "usi.lbl.diametr_vorotnoy_veny_mm",
  "Диаметры поверхностных вен (при оценке ХВН)": "usi.lbl.diametry_poverhnostnyh_ven_pri_ocenke_hvn",
  "Динамические признаки": "usi.lbl.dinamicheskie_priznaki",
  "Динамическое исследование": "usi.lbl.dinamicheskoe_issledovanie",
  "Дистальный отдел, переднезадний диаметр, мм": "usi.lbl.distalnyy_otdel_perednezadniy_diametr_mm",
  "Дистальный отдел, поперечный диаметр, мм": "usi.lbl.distalnyy_otdel_poperechnyy_diametr_mm",
  "Дистальный сегмент: EDV, см/с": "usi.lbl.distalnyy_segment_edv_sm_s",
  "Дистальный сегмент: PSV, см/с": "usi.lbl.distalnyy_segment_psv_sm_s",
  "Длина флотирующего компонента, мм": "usi.lbl.dlina_flotiruyuschego_komponenta_mm",
  "Длина, мм": "usi.lbl.dlina_mm",
  "Длинная ось, мм": "usi.lbl.dlinnaya_os_mm",
  "Дополнительно": "usi.lbl.dopolnitelno",
  "Дополнительные характеристики": "usi.lbl.dopolnitelnye_harakteristiki",
  "Дополнительные почечные артерии": "usi.lbl.dopolnitelnye_pochechnye_arterii",
  "Дополнительные признаки": "usi.lbl.dopolnitelnye_priznaki",
  "Допплерография": "usi.lbl.dopplerografiya",
  "Дуплексное сканирование артерий нижних конечностей": "usi.lbl.dupleksnoe_skanirovanie_arteriy_nizhnih_konechnostey",
  "ДУПЛЕКСНОЕ СКАНИРОВАНИЕ АРТЕРИЙ НИЖНИХ КОНЕЧНОСТЕЙ": "usi.lbl.dupleksnoe_skanirovanie_arteriy_nizhnih_konechnostey_2",
  "Дуплексное сканирование артерий верхних конечностей": "usi.lbl.dupleksnoe_skanirovanie_arteriy_verhnih_konechnostey",
  "ДУПЛЕКСНОЕ СКАНИРОВАНИЕ АРТЕРИЙ ВЕРХНИХ КОНЕЧНОСТЕЙ": "usi.lbl.dupleksnoe_skanirovanie_arteriy_verhnih_konechnostey_2",
  "Дуплексное сканирование БЦА": "usi.lbl.dupleksnoe_skanirovanie_bca",
  "Дуплексное сканирование брюшной аорты и ветвей": "usi.lbl.dupleksnoe_skanirovanie_bryushnoy_aorty_i_vetvey",
  "Дуплексное сканирование экстракраниальных отделов БЦА": "usi.lbl.dupleksnoe_skanirovanie_ekstrakranialnyh_otdelov_bca",
  "Дуплексное сканирование почечных артерий": "usi.lbl.dupleksnoe_skanirovanie_pochechnyh_arteriy",
  "Дуплексное сканирование вен нижних конечностей": "usi.lbl.dupleksnoe_skanirovanie_ven_nizhnih_konechnostey",
  "Дуплексное сканирование вен верхних конечностей": "usi.lbl.dupleksnoe_skanirovanie_ven_verhnih_konechnostey",
  "единичный / множественные": "usi.lbl.edinichnyy_mnozhestvennye",
  "EDV, см/с": "usi.lbl.edv_sm_s",
  "Эхогенность": "usi.lbl.ehogennost",
  "Эхогенность / эхоструктура": "usi.lbl.ehogennost_ehostruktura",
  "Эхоструктура": "usi.lbl.ehostruktura",
  "Эндометрий": "usi.lbl.endometriy",
  "Энтезисы": "usi.lbl.entezisy",
  "Флотирующий компонент": "usi.lbl.flotiruyuschiy_komponent",
  "Фолликулы / доминантный фолликул / желтое тело": "usi.lbl.follikuly_dominantnyy_follikul_zheltoe_telo",
  "Форма": "usi.lbl.forma",
  "Гемодинамическая значимость": "usi.lbl.gemodinamicheskaya_znachimost",
  "гипоэхогенные / неоднородные / гиперэхогенные": "usi.lbl.gipoehogennye_neodnorodnye_giperehogennye",
  "Главный панкреатический проток, мм": "usi.lbl.glavnyy_pankreaticheskiy_protok_mm",
  "Глубокие вены": "usi.lbl.glubokie_veny",
  "Гобечия И. А. - УЗИ брахиоцефальных артерий": "usi.lbl.gobechiya_i_a_uzi_brahiocefalnyh_arteriy",
  "Гобечия И. А. - УЗИ молочных желез": "usi.lbl.gobechiya_i_a_uzi_molochnyh_zhelez",
  "Гобечия И. А. - УЗИ органов брюшной полости": "usi.lbl.gobechiya_i_a_uzi_organov_bryushnoy_polosti",
  "Гобечия И. А. - УЗИ органов малого таза": "usi.lbl.gobechiya_i_a_uzi_organov_malogo_taza",
  "Гобечия И. А. - УЗИ щитовидной железы и паращитовидных желез": "usi.lbl.gobechiya_i_a_uzi_schitovidnoy_zhelezy_i_paraschitovidnyh_zh",
  "Гобечия И. А. - УЗИ вен нижних конечностей": "usi.lbl.gobechiya_i_a_uzi_ven_nizhnih_konechnostey",
  "Головка, мм": "usi.lbl.golovka_mm",
  "Головная": "usi.lbl.golovnaya",
  "Характер поражения": "usi.lbl.harakter_porazheniya",
  "Характер спектра": "usi.lbl.harakter_spektra",
  "Хвост, мм": "usi.lbl.hvost_mm",
  "Хвостатая доля, мм": "usi.lbl.hvostataya_dolya_mm",
  "имеется": "usi.lbl.imeetsya",
  "имеются": "usi.lbl.imeyutsya",
  "Индекс резистентности слева": "usi.lbl.indeks_rezistentnosti_sleva",
  "Индекс резистентности справа": "usi.lbl.indeks_rezistentnosti_sprava",
  "Интра- / экстратестикулярное расположение": "usi.lbl.intra_ekstratestikulyarnoe_raspolozhenie",
  "Интравезикальная простатическая протрузия, мм": "usi.lbl.intravezikalnaya_prostaticheskaya_protruziya_mm",
  "Исследуемая область / сустав": "usi.lbl.issleduemaya_oblast_sustav",
  "Исследуемые зоны": "usi.lbl.issleduemye_zony",
  "Качество визуализации": "usi.lbl.kachestvo_vizualizacii",
  "Кальцинаты": "usi.lbl.kalcinaty",
  "Кальцинаты / эхогенные включения": "usi.lbl.kalcinaty_ehogennye_vklyucheniya",
  "Кальцинаты / энтезофиты / эрозии": "usi.lbl.kalcinaty_entezofity_erozii",
  "Кальцинаты / конкременты": "usi.lbl.kalcinaty_konkrementy",
  "Катетер / порт / иное устройство и отношение тромба": "usi.lbl.kateter_port_inoe_ustroystvo_i_otnoshenie_tromba",
  "Количество": "usi.lbl.kolichestvo",
  "Коллатеральный кровоток": "usi.lbl.kollateralnyy_krovotok",
  "Комментарий": "usi.lbl.kommentariy",
  "Комплексное УЗИ мочевыделительной системы": "usi.lbl.kompleksnoe_uzi_mochevydelitelnoy_sistemy",
  "Компрессия": "usi.lbl.kompressiya",
  "Компрессия вены": "usi.lbl.kompressiya_veny",
  "Конгломераты": "usi.lbl.konglomeraty",
  "Контуры": "usi.lbl.kontury",
  "Корковый слой": "usi.lbl.korkovyy_sloy",
  "Короткая ось, мм": "usi.lbl.korotkaya_os_mm",
  "Кортико-медуллярная дифференцировка": "usi.lbl.kortiko_medullyarnaya_differencirovka",
  "Краниокаудальный размер, мм": "usi.lbl.kraniokaudalnyy_razmer_mm",
  "левая": "usi.lbl.levaya",
  "Левая": "usi.lbl.levaya_2",
  "Левая доля": "usi.lbl.levaya_dolya",
  "Левая доля, переднезадний размер, мм": "usi.lbl.levaya_dolya_perednezadniy_razmer_mm",
  "Левая молочная железа": "usi.lbl.levaya_molochnaya_zheleza",
  "Левая нижняя конечность": "usi.lbl.levaya_nizhnyaya_konechnost",
  "Левая почечная артерия": "usi.lbl.levaya_pochechnaya_arteriya",
  "Левая почка": "usi.lbl.levaya_pochka",
  "Левая сторона: EDV, см/с": "usi.lbl.levaya_storona_edv_sm_s",
  "Левая сторона: PSV, см/с": "usi.lbl.levaya_storona_psv_sm_s",
  "Левая сторона: RI": "usi.lbl.levaya_storona_ri",
  "Левая верхняя конечность": "usi.lbl.levaya_verhnyaya_konechnost",
  "Левое яичко": "usi.lbl.levoe_yaichko",
  "Левый надпочечник": "usi.lbl.levyy_nadpochechnik",
  "Левый яичник": "usi.lbl.levyy_yaichnik",
  "Лимфатические узлы": "usi.lbl.limfaticheskie_uzly",
  "Локализация": "usi.lbl.lokalizaciya",
  "Локализация / анатомическая группа": "usi.lbl.lokalizaciya_anatomicheskaya_gruppa",
  "Локальная турбулентность / aliasing": "usi.lbl.lokalnaya_turbulentnost_aliasing",
  "Локальное изменение скоростных показателей": "usi.lbl.lokalnoe_izmenenie_skorostnyh_pokazateley",
  "Локтевая": "usi.lbl.loktevaya",
  "Локтевые": "usi.lbl.loktevye",
  "Локтевые лимфатические узлы": "usi.lbl.loktevye_limfaticheskie_uzly",
  "Лучевая": "usi.lbl.luchevaya",
  "Лучевые": "usi.lbl.luchevye",
  "М-эхо, мм": "usi.lbl.m_eho_mm",
  "Максимальная толщина, мм": "usi.lbl.maksimalnaya_tolschina_mm",
  "Максимальная толщина тромботических масс, мм": "usi.lbl.maksimalnaya_tolschina_tromboticheskih_mass_mm",
  "Максимальный диаметр, мм": "usi.lbl.maksimalnyy_diametr_mm",
  "Максимальный диаметр в любой плоскости, мм": "usi.lbl.maksimalnyy_diametr_v_lyuboy_ploskosti_mm",
  "Максимальный диаметр вен слева в покое, мм": "usi.lbl.maksimalnyy_diametr_ven_sleva_v_pokoe_mm",
  "Максимальный диаметр вен справа в покое, мм": "usi.lbl.maksimalnyy_diametr_ven_sprava_v_pokoe_mm",
  "Максимальный наружный диаметр, мм": "usi.lbl.maksimalnyy_naruzhnyy_diametr_mm",
  "Максимальный наружный переднезадний диаметр, мм": "usi.lbl.maksimalnyy_naruzhnyy_perednezadniy_diametr_mm",
  "Малая подкожная вена слева, с": "usi.lbl.malaya_podkozhnaya_vena_sleva_s",
  "Малая подкожная вена справа, с": "usi.lbl.malaya_podkozhnaya_vena_sprava_s",
  "Матка": "usi.lbl.matka",
  "Маточные трубы / придатки": "usi.lbl.matochnye_truby_pridatki",
  "Метод оценки": "usi.lbl.metod_ocenki",
  "Мочеточники": "usi.lbl.mochetochniki",
  "Мочевой пузырь": "usi.lbl.mochevoy_puzyr",
  "Мошонка": "usi.lbl.moshonka",
  "Мышцы и подкожные мягкие ткани": "usi.lbl.myshcy_i_podkozhnye_myagkie_tkani",
  "Мышечные вены голени": "usi.lbl.myshechnye_veny_goleni",
  "Надключичные и подключичные лимфатические узлы": "usi.lbl.nadklyuchichnye_i_podklyuchichnye_limfaticheskie_uzly",
  "Наружные сонные артерии": "usi.lbl.naruzhnye_sonnye_arterii",
  "NASCET / локально по диаметру / по площади": "usi.lbl.nascet_lokalno_po_diametru_po_ploschadi",
  "не определяется / мм": "usi.lbl.ne_opredelyaetsya_mm",
  "не визуализируются / визуализируются": "usi.lbl.ne_vizualiziruyutsya_vizualiziruyutsya",
  "не выявлен": "usi.lbl.ne_vyyavlen",
  "не выявлены / выявлены": "usi.lbl.ne_vyyavleny_vyyavleny",
  "Некроз / кистозные изменения": "usi.lbl.nekroz_kistoznye_izmeneniya",
  "нет": "usi.lbl.net",
  "Нижняя брыжеечная артерия": "usi.lbl.nizhnyaya_bryzheechnaya_arteriya",
  "НСА": "usi.lbl.nsa",
  "обе": "usi.lbl.obe",
  "Объем до мочеиспускания, мл": "usi.lbl.obem_do_mocheispuskaniya_ml",
  "Объем левой доли, мл": "usi.lbl.obem_levoy_doli_ml",
  "Объем, мл": "usi.lbl.obem_ml",
  "Объем мочевого пузыря после мочеиспускания, мл": "usi.lbl.obem_mochevogo_puzyrya_posle_mocheispuskaniya_ml",
  "Объем остаточной мочи, мл": "usi.lbl.obem_ostatochnoy_mochi_ml",
  "Объем правой доли, мл": "usi.lbl.obem_pravoy_doli_ml",
  "Объем щитовидной железы": "usi.lbl.obem_schitovidnoy_zhelezy",
  "Объем, см³": "usi.lbl.obem_sm",
  "Область ворот печени": "usi.lbl.oblast_vorot_pecheni",
  "ОБП": "usi.lbl.obp",
  "Общая бедренная": "usi.lbl.obschaya_bedrennaya",
  "Общая бедренная вена слева, с": "usi.lbl.obschaya_bedrennaya_vena_sleva_s",
  "Общая бедренная вена справа, с": "usi.lbl.obschaya_bedrennaya_vena_sprava_s",
  "Общая характеристика": "usi.lbl.obschaya_harakteristika",
  "Общая ультразвуковая характеристика": "usi.lbl.obschaya_ultrazvukovaya_harakteristika",
  "Общие подвздошные артерии": "usi.lbl.obschie_podvzdoshnye_arterii",
  "Общие сонные артерии": "usi.lbl.obschie_sonnye_arterii",
  "Общий желчный проток, мм": "usi.lbl.obschiy_zhelchnyy_protok_mm",
  "Оценка риска IOTA ADNEX / иная система": "usi.lbl.ocenka_riska_iota_adnex_inaya_sistema",
  "Оценка венозного рефлюкса": "usi.lbl.ocenka_venoznogo_reflyuksa",
  "Очаговое образование № 1": "usi.lbl.ochagovoe_obrazovanie_1",
  "Очаговое образование № 2": "usi.lbl.ochagovoe_obrazovanie_2",
  "Очаговые образования / узлы — EU-TIRADS": "usi.lbl.ochagovye_obrazovaniya_uzly_eu_tirads",
  "окклюзивный / неокклюзивный": "usi.lbl.okklyuzivnyy_neokklyuzivnyy",
  "Окклюзия": "usi.lbl.okklyuziya",
  "Окружающие ткани": "usi.lbl.okruzhayuschie_tkani",
  "Описание измененного / доминантного лимфатического узла": "usi.lbl.opisanie_izmenennogo_dominantnogo_limfaticheskogo_uzla",
  "ОСА": "usi.lbl.osa",
  "Остаточная моча": "usi.lbl.ostatochnaya_mocha",
  "Отношение к капсуле": "usi.lbl.otnoshenie_k_kapsule",
  "Отношение PSV в зоне стеноза к проксимальному сегменту": "usi.lbl.otnoshenie_psv_v_zone_stenoza_k_proksimalnomu_segmentu",
  "Отношение PSV ВСА / PSV ОСА слева": "usi.lbl.otnoshenie_psv_vsa_psv_osa_sleva",
  "Отношение PSV ВСА / PSV ОСА справа": "usi.lbl.otnoshenie_psv_vsa_psv_osa_sprava",
  "Отношение скоростей в зоне стеноза / проксимальном сегменте": "usi.lbl.otnoshenie_skorostey_v_zone_stenoza_proksimalnom_segmente",
  "отсутствует": "usi.lbl.otsutstvuet",
  "отсутствует / частичная": "usi.lbl.otsutstvuet_chastichnaya",
  "отсутствует / частичная / сохранена": "usi.lbl.otsutstvuet_chastichnaya_sohranena",
  "отсутствует / частичное / сохранено": "usi.lbl.otsutstvuet_chastichnoe_sohraneno",
  "отсутствуют": "usi.lbl.otsutstvuyut",
  "овальная / округлая / неправильная": "usi.lbl.ovalnaya_okruglaya_nepravilnaya",
  "ПА": "usi.lbl.pa",
  "Паховые лимфатические узлы": "usi.lbl.pahovye_limfaticheskie_uzly",
  "Памятка по EU-TIRADS": "usi.lbl.pamyatka_po_eu_tirads",
  "Папиллярные структуры": "usi.lbl.papillyarnye_struktury",
  "параллельная коже / непараллельная коже": "usi.lbl.parallelnaya_kozhe_neparallelnaya_kozhe",
  "Парапростатические ткани": "usi.lbl.paraprostaticheskie_tkani",
  "Печень": "usi.lbl.pechen",
  "Переднезадний размер, мм": "usi.lbl.perednezadniy_razmer_mm",
  "Переднезадний размер перешейка, мм": "usi.lbl.perednezadniy_razmer_peresheyka_mm",
  "Передняя большеберцовая": "usi.lbl.perednyaya_bolshebercovaya",
  "Перегородки": "usi.lbl.peregorodki",
  "Перфорантные вены": "usi.lbl.perforantnye_veny",
  "Перифокальные ткани": "usi.lbl.perifokalnye_tkani",
  "Периуретральная область и срединная доля": "usi.lbl.periuretralnaya_oblast_i_sredinnaya_dolya",
  "Плечевая": "usi.lbl.plechevaya",
  "Плечевые": "usi.lbl.plechevye",
  "Площадь максимального продольного сечения, см²": "usi.lbl.ploschad_maksimalnogo_prodolnogo_secheniya_sm",
  "Почечно-аортальное отношение (RAR)": "usi.lbl.pochechno_aortalnoe_otnoshenie_rar",
  "почек и надпочечников норма": "usi.lbl.pochek_i_nadpochechnikov_norma",
  "Подключичная": "usi.lbl.podklyuchichnaya",
  "Подключичная артерия": "usi.lbl.podklyuchichnaya_arteriya",
  "Подключичные артерии": "usi.lbl.podklyuchichnye_arterii",
  "Подколенная": "usi.lbl.podkolennaya",
  "Подколенная вена слева, с": "usi.lbl.podkolennaya_vena_sleva_s",
  "Подколенная вена справа, с": "usi.lbl.podkolennaya_vena_sprava_s",
  "Подмышечная": "usi.lbl.podmyshechnaya",
  "Подмышечные лимфатические узлы": "usi.lbl.podmyshechnye_limfaticheskie_uzly",
  "Поджелудочная железа": "usi.lbl.podzheludochnaya_zheleza",
  "Показатель": "usi.lbl.pokazatel",
  "Положение": "usi.lbl.polozhenie",
  "Поперечный диаметр, мм": "usi.lbl.poperechnyy_diametr_mm",
  "Поперечный размер, мм": "usi.lbl.poperechnyy_razmer_mm",
  "Постстенотическая турбулентность": "usi.lbl.poststenoticheskaya_turbulentnost",
  "Постстенотические изменения": "usi.lbl.poststenoticheskie_izmeneniya",
  "Постстенотические изменения кровотока": "usi.lbl.poststenoticheskie_izmeneniya_krovotoka",
  "Поверхность": "usi.lbl.poverhnost",
  "Поверхностная бедренная (дист.)": "usi.lbl.poverhnostnaya_bedrennaya_dist",
  "Поверхностная бедренная (прокс.)": "usi.lbl.poverhnostnaya_bedrennaya_proks",
  "Поверхностные вены": "usi.lbl.poverhnostnye_veny",
  "Power/Color Doppler активность": "usi.lbl.power_color_doppler_aktivnost",
  "Позадиматочное пространство": "usi.lbl.pozadimatochnoe_prostranstvo",
  "Позвоночные артерии": "usi.lbl.pozvonochnye_arterii",
  "правая": "usi.lbl.pravaya",
  "Правая": "usi.lbl.pravaya_2",
  "Правая доля": "usi.lbl.pravaya_dolya",
  "Правая доля, косой вертикальный размер, мм": "usi.lbl.pravaya_dolya_kosoy_vertikalnyy_razmer_mm",
  "Правая доля, переднезадний размер, мм": "usi.lbl.pravaya_dolya_perednezadniy_razmer_mm",
  "Правая молочная железа": "usi.lbl.pravaya_molochnaya_zheleza",
  "Правая нижняя конечность": "usi.lbl.pravaya_nizhnyaya_konechnost",
  "Правая почечная артерия": "usi.lbl.pravaya_pochechnaya_arteriya",
  "Правая почка": "usi.lbl.pravaya_pochka",
  "Правая сторона: EDV, см/с": "usi.lbl.pravaya_storona_edv_sm_s",
  "Правая сторона: PSV, см/с": "usi.lbl.pravaya_storona_psv_sm_s",
  "Правая сторона: RI": "usi.lbl.pravaya_storona_ri",
  "Правая верхняя конечность": "usi.lbl.pravaya_verhnyaya_konechnost",
  "Правое яичко": "usi.lbl.pravoe_yaichko",
  "Правый надпочечник": "usi.lbl.pravyy_nadpochechnik",
  "Правый яичник": "usi.lbl.pravyy_yaichnik",
  "Предстательная железа": "usi.lbl.predstatelnaya_zheleza",
  "Предыдущие исследования": "usi.lbl.predyduschie_issledovaniya",
  "При выявлении аневризмы / дилатации": "usi.lbl.pri_vyyavlenii_anevrizmy_dilatacii",
  "При выявлении атеросклеротической бляшки / стеноза": "usi.lbl.pri_vyyavlenii_ateroskleroticheskoy_blyashki_stenoza",
  "При выявлении деформации": "usi.lbl.pri_vyyavlenii_deformacii",
  "При выявлении образования яичника / придатков": "usi.lbl.pri_vyyavlenii_obrazovaniya_yaichnika_pridatkov",
  "При выявлении очагового изменения": "usi.lbl.pri_vyyavlenii_ochagovogo_izmeneniya",
  "При выявлении очагового образования": "usi.lbl.pri_vyyavlenii_ochagovogo_obrazovaniya",
  "При выявлении патологического изменения": "usi.lbl.pri_vyyavlenii_patologicheskogo_izmeneniya",
  "При выявлении стеноза": "usi.lbl.pri_vyyavlenii_stenoza",
  "При выявлении стеноза / окклюзии": "usi.lbl.pri_vyyavlenii_stenoza_okklyuzii",
  "При выявлении стеноза висцеральной ветви": "usi.lbl.pri_vyyavlenii_stenoza_visceralnoy_vetvi",
  "При выявлении тромбоза": "usi.lbl.pri_vyyavlenii_tromboza",
  "Придаток левого яичка": "usi.lbl.pridatok_levogo_yaichka",
  "Придаток правого яичка": "usi.lbl.pridatok_pravogo_yaichka",
  "Примечание": "usi.lbl.primechanie",
  "Пристеночные тромботические массы": "usi.lbl.pristenochnye_tromboticheskie_massy",
  "Признаки реканализации": "usi.lbl.priznaki_rekanalizacii",
  "Проксимальная граница тромба": "usi.lbl.proksimalnaya_granica_tromba",
  "Проксимальный отдел, переднезадний диаметр, мм": "usi.lbl.proksimalnyy_otdel_perednezadniy_diametr_mm",
  "Проксимальный отдел, поперечный диаметр, мм": "usi.lbl.proksimalnyy_otdel_poperechnyy_diametr_mm",
  "Проксимальный сегмент: EDV, см/с": "usi.lbl.proksimalnyy_segment_edv_sm_s",
  "Проксимальный сегмент: PSV, см/с": "usi.lbl.proksimalnyy_segment_psv_sm_s",
  "Протокол": "usi.lbl.protokol",
  "Протяженность бляшки, мм": "usi.lbl.protyazhennost_blyashki_mm",
  "Протяженность окклюзии, мм": "usi.lbl.protyazhennost_okklyuzii_mm",
  "Протяженность поражения, мм": "usi.lbl.protyazhennost_porazheniya_mm",
  "Протяженность расширенного сегмента, мм": "usi.lbl.protyazhennost_rasshirennogo_segmenta_mm",
  "ПСА общий / свободный (при наличии)": "usi.lbl.psa_obschiy_svobodnyy_pri_nalichii",
  "PSV аорты на уровне отхождения почечных артерий, см/с": "usi.lbl.psv_aorty_na_urovne_othozhdeniya_pochechnyh_arteriy_sm_s",
  "PSV дистальнее, см/с": "usi.lbl.psv_distalnee_sm_s",
  "PSV до стеноза, см/с": "usi.lbl.psv_do_stenoza_sm_s",
  "PSV после стеноза, см/с": "usi.lbl.psv_posle_stenoza_sm_s",
  "PSV проксимальнее поражения, см/с": "usi.lbl.psv_proksimalnee_porazheniya_sm_s",
  "PSV, см/с": "usi.lbl.psv_sm_s",
  "PSV в зоне максимального ускорения, см/с": "usi.lbl.psv_v_zone_maksimalnogo_uskoreniya_sm_s",
  "PSV в зоне стеноза, см/с": "usi.lbl.psv_v_zone_stenoza_sm_s",
  "PSV ВСА/ОСА": "usi.lbl.psv_vsa_osa",
  "RAR": "usi.lbl.rar",
  "Размер головки придатка, мм": "usi.lbl.razmer_golovki_pridatka_mm",
  "Размеры, мм": "usi.lbl.razmery_mm",
  "Размеры патологического участка, мм": "usi.lbl.razmery_patologicheskogo_uchastka_mm",
  "Регионарные лимфатические узлы": "usi.lbl.regionarnye_limfaticheskie_uzly",
  "Рекомендации": "usi.lbl.rekomendacii",
  "RI": "usi.lbl.ri",
  "ровная / неровная / изъязвленная": "usi.lbl.rovnaya_nerovnaya_izyazvlennaya",
  "Щитовидная железа": "usi.lbl.schitovidnaya_zheleza",
  "Сегмент": "usi.lbl.segment",
  "Селезенка": "usi.lbl.selezenka",
  "Селезеночная вена в области ворот, мм": "usi.lbl.selezenochnaya_vena_v_oblasti_vorot_mm",
  "Семенные канатики": "usi.lbl.semennye_kanatiki",
  "Семенные пузырьки": "usi.lbl.semennye_puzyrki",
  "Семявыносящие протоки": "usi.lbl.semyavynosyaschie_protoki",
  "Шейка матки": "usi.lbl.sheyka_matki",
  "Шейные лимфатические узлы": "usi.lbl.sheynye_limfaticheskie_uzly",
  "Ширина, мм": "usi.lbl.shirina_mm",
  "Синовиальная гипертрофия": "usi.lbl.sinovialnaya_gipertrofiya",
  "Слева, мм": "usi.lbl.sleva_mm",
  "Содержимое": "usi.lbl.soderzhimoe",
  "Солидный компонент": "usi.lbl.solidnyy_komponent",
  "Соотношение длинной и короткой осей (L/S)": "usi.lbl.sootnoshenie_dlinnoy_i_korotkoy_osey_l_s",
  "Сосуды печени": "usi.lbl.sosudy_pecheni",
  "Спектр": "usi.lbl.spektr",
  "Спектральные показатели": "usi.lbl.spektralnye_pokazateli",
  "Справа, мм": "usi.lbl.sprava_mm",
  "Срединная доля / интравезикальная протрузия": "usi.lbl.sredinnaya_dolya_intravezikalnaya_protruziya",
  "Средний отдел, переднезадний диаметр, мм": "usi.lbl.sredniy_otdel_perednezadniy_diametr_mm",
  "Средний отдел, поперечный диаметр, мм": "usi.lbl.sredniy_otdel_poperechnyy_diametr_mm",
  "Средний сегмент: EDV, см/с": "usi.lbl.sredniy_segment_edv_sm_s",
  "Средний сегмент: PSV, см/с": "usi.lbl.sredniy_segment_psv_sm_s",
  "Степень стеноза, %": "usi.lbl.stepen_stenoza",
  "Сторона": "usi.lbl.storona",
  "Сторона / локализация": "usi.lbl.storona_lokalizaciya",
  "Структура": "usi.lbl.struktura",
  "Структура / локализация": "usi.lbl.struktura_lokalizaciya",
  "Структура / поверхность": "usi.lbl.struktura_poverhnost",
  "Сухожилие": "usi.lbl.suhozhilie",
  "Сухожилия": "usi.lbl.suhozhiliya",
  "Суммарный объем, мл": "usi.lbl.summarnyy_obem_ml",
  "Сустав": "usi.lbl.sustav",
  "Суставная капсула и связки": "usi.lbl.sustavnaya_kapsula_i_svyazki",
  "Свободная жидкость": "usi.lbl.svobodnaya_zhidkost",
  "Свободный просвет, мм": "usi.lbl.svobodnyy_prosvet_mm",
  "Сводная таблица": "usi.lbl.svodnaya_tablica",
  "Связь с окружающими структурами": "usi.lbl.svyaz_s_okruzhayuschimi_strukturami",
  "Связка": "usi.lbl.svyazka",
  "Таблица оценки проходимости": "usi.lbl.tablica_ocenki_prohodimosti",
  "Тело, мм": "usi.lbl.telo_mm",
  "Тип": "usi.lbl.tip",
  "Тип деформации": "usi.lbl.tip_deformacii",
  "Толщина комплекса интима–медиа слева, мм": "usi.lbl.tolschina_kompleksa_intima_media_sleva_mm",
  "Толщина комплекса интима–медиа справа, мм": "usi.lbl.tolschina_kompleksa_intima_media_sprava_mm",
  "Толщина, мм": "usi.lbl.tolschina_mm",
  "Толщина паренхимы, мм": "usi.lbl.tolschina_parenhimy_mm",
  "Толщина паренхимы в среднем сегменте, мм": "usi.lbl.tolschina_parenhimy_v_srednem_segmente_mm",
  "Толщина стенки, мм": "usi.lbl.tolschina_stenki_mm",
  "Тромботические массы": "usi.lbl.tromboticheskie_massy",
  "Тромбоз": "usi.lbl.tromboz",
  "ТРУЗИ предстательной железы": "usi.lbl.truzi_predstatelnoy_zhelezy",
  "Тыльная артерия стопы": "usi.lbl.tylnaya_arteriya_stopy",
  "Ультразвуковые признаки гемодинамически значимого стеноза": "usi.lbl.ultrazvukovye_priznaki_gemodinamicheski_znachimogo_stenoza",
  "Условия исследования": "usi.lbl.usloviya_issledovaniya",
  "Устье: EDV, см/с": "usi.lbl.uste_edv_sm_s",
  "устье / проксимальный / средний / дистальный сегмент": "usi.lbl.uste_proksimalnyy_sredniy_distalnyy_segment",
  "Устье: PSV, см/с": "usi.lbl.uste_psv_sm_s",
  "Уточнение изменения скоростей": "usi.lbl.utochnenie_izmeneniya_skorostey",
  "Уточнение постстенотических изменений": "usi.lbl.utochnenie_poststenoticheskih_izmeneniy",
  "Уточнение реканализации": "usi.lbl.utochnenie_rekanalizacii",
  "Уточнение вовлечения подвздошных артерий": "usi.lbl.utochnenie_vovlecheniya_podvzdoshnyh_arteriy",
  "Узел № 1": "usi.lbl.uzel_1",
  "Узел № 2": "usi.lbl.uzel_2",
  "УЗИ артерий нижних конечностей": "usi.lbl.uzi_arteriy_nizhnih_konechnostey",
  "УЗИ артерий верхних конечностей": "usi.lbl.uzi_arteriy_verhnih_konechnostey",
  "УЗИ БЦА": "usi.lbl.uzi_bca",
  "УЗИ брахиоцефальных артерий": "usi.lbl.uzi_brahiocefalnyh_arteriy",
  "УЗИ брюшной аорты и ветвей": "usi.lbl.uzi_bryushnoy_aorty_i_vetvey",
  "УЗИ мочевыделительной системы": "usi.lbl.uzi_mochevydelitelnoy_sistemy",
  "УЗИ мочевыделительной системы (комплексное)": "usi.lbl.uzi_mochevydelitelnoy_sistemy_kompleksnoe",
  "УЗИ мочевыносящей системы": "usi.lbl.uzi_mochevynosyaschey_sistemy",
  "УЗИ молочных желез": "usi.lbl.uzi_molochnyh_zhelez",
  "УЗИ молочных желез (BI-RADS)": "usi.lbl.uzi_molochnyh_zhelez_bi_rads",
  "УЗИ молочных желез BI RADS": "usi.lbl.uzi_molochnyh_zhelez_bi_rads_2",
  "УЗИ органов брюшной полости": "usi.lbl.uzi_organov_bryushnoy_polosti",
  "УЗИ органов брюшной полости и забрюшинного пространства": "usi.lbl.uzi_organov_bryushnoy_polosti_i_zabryushinnogo_prostranstva",
  "УЗИ органов малого таза": "usi.lbl.uzi_organov_malogo_taza",
  "УЗИ органов малого таза (ТА / ТВ)": "usi.lbl.uzi_organov_malogo_taza_ta_tv",
  "УЗИ органов малого таза (женщины, ТА/ТВ)": "usi.lbl.uzi_organov_malogo_taza_zhenschiny_ta_tv",
  "УЗИ органов малого таза женщины ТА ТВ": "usi.lbl.uzi_organov_malogo_taza_zhenschiny_ta_tv_2",
  "УЗИ органов мошонки (ЦДК)": "usi.lbl.uzi_organov_moshonki_cdk",
  "УЗИ органов мошонки ЦДК": "usi.lbl.uzi_organov_moshonki_cdk_2",
  "УЗИ органов мошонки с ЦДК": "usi.lbl.uzi_organov_moshonki_s_cdk",
  "УЗИ печени и желчевыводящей системы": "usi.lbl.uzi_pecheni_i_zhelchevyvodyaschey_sistemy",
  "УЗИ почечных артерий": "usi.lbl.uzi_pochechnyh_arteriy",
  "УЗИ почек и надпочечников": "usi.lbl.uzi_pochek_i_nadpochechnikov",
  "УЗИ поверхностных лимфатических узлов": "usi.lbl.uzi_poverhnostnyh_limfaticheskih_uzlov",
  "УЗИ предстательной железы (трансабдоминально)": "usi.lbl.uzi_predstatelnoy_zhelezy_transabdominalno",
  "УЗИ предстательной железы трансабдоминально": "usi.lbl.uzi_predstatelnoy_zhelezy_transabdominalno_2",
  "УЗИ предстательной железы (ТРУЗИ)": "usi.lbl.uzi_predstatelnoy_zhelezy_truzi",
  "УЗИ щитовидной железы (EU-TIRADS)": "usi.lbl.uzi_schitovidnoy_zhelezy_eu_tirads",
  "УЗИ щитовидной железы EU TIRADS": "usi.lbl.uzi_schitovidnoy_zhelezy_eu_tirads_2",
  "УЗИ щитовидной железы и паращитовидных желез": "usi.lbl.uzi_schitovidnoy_zhelezy_i_paraschitovidnyh_zhelez",
  "УЗИ сустава и периартикулярных мягких тканей": "usi.lbl.uzi_sustava_i_periartikulyarnyh_myagkih_tkaney",
  "УЗИ суставов и периартикулярных мягких тканей": "usi.lbl.uzi_sustavov_i_periartikulyarnyh_myagkih_tkaney",
  "УЗИ вен нижних конечностей": "usi.lbl.uzi_ven_nizhnih_konechnostey",
  "УЗИ вен верхних конечностей": "usi.lbl.uzi_ven_verhnih_konechnostey",
  "Васкуляризация": "usi.lbl.vaskulyarizaciya",
  "Вена": "usi.lbl.vena",
  "Вена / сегмент": "usi.lbl.vena_segment",
  "Вены лозовидного сплетения": "usi.lbl.veny_lozovidnogo_spleteniya",
  "Верхняя брыжеечная артерия": "usi.lbl.verhnyaya_bryzheechnaya_arteriya",
  "Внепеченочные желчные протоки": "usi.lbl.vnepechenochnye_zhelchnye_protoki",
  "Внутренние сонные артерии": "usi.lbl.vnutrennie_sonnye_arterii",
  "Внутренняя стенка": "usi.lbl.vnutrennyaya_stenka",
  "Внутренняя яремная": "usi.lbl.vnutrennyaya_yaremnaya",
  "Внутрипеченочные желчные протоки": "usi.lbl.vnutripechenochnye_zhelchnye_protoki",
  "Внутрипочечный кровоток": "usi.lbl.vnutripochechnyy_krovotok",
  "Внутрипочечный спектр tardus-parvus": "usi.lbl.vnutripochechnyy_spektr_tardus_parvus",
  "Воротная вена, мм": "usi.lbl.vorotnaya_vena_mm",
  "Вовлечение подвздошных артерий": "usi.lbl.vovlechenie_podvzdoshnyh_arteriy",
  "Время ускорения (AT) слева, мс": "usi.lbl.vremya_uskoreniya_at_sleva_ms",
  "Время ускорения (AT) справа, мс": "usi.lbl.vremya_uskoreniya_at_sprava_ms",
  "ВСА": "usi.lbl.vsa",
  "выявлен": "usi.lbl.vyyavlen",
  "—": "usi.lbl.x",
  "Задние акустические эффекты": "usi.lbl.zadnie_akusticheskie_effekty",
  "Задняя большеберцовая": "usi.lbl.zadnyaya_bolshebercovaya",
  "Заключение": "usi.lbl.zaklyuchenie",
  "Желчные протоки": "usi.lbl.zhelchnye_protoki",
  "Желчный пузырь": "usi.lbl.zhelchnyy_puzyr",
  "Жидкость / выпот": "usi.lbl.zhidkost_vypot",
  "Жировые ворота": "usi.lbl.zhirovye_vorota",
  "Зональная анатомия": "usi.lbl.zonalnaya_anatomiya",
};

export const usiKeyForText = (text) =>
  USI_LABEL_KEYS[String(text ?? "").trim()] || "";
